import { render, staticRenderFns } from "./DialogAuthorization.vue?vue&type=template&id=d2d95f42&scoped=true&"
import script from "./DialogAuthorization.vue?vue&type=script&lang=js&"
export * from "./DialogAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./DialogAuthorization.vue?vue&type=style&index=0&id=d2d95f42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d95f42",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TimerAndActionSendSmsInAuth: require('/var/www/linza-front/linza-front-20251128110242/components/common/TimerAndActionSendSmsInAuth.vue').default})
